__turbopack_context__.v({
  "container": "styles-module__vxAqJq__container",
  "imageContainer": "styles-module__vxAqJq__imageContainer",
});
